import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import { FeaturePayload, FeatureType } from './types'

export class FeaturePageService {
  static getFeatures(
    config: AxiosRequestConfig,
  ): Promise<AxiosResponse<FeatureType[]>> {
    return apiService.get<AxiosResponse<FeatureType[]>>('/features', config)
  }

  static getFeatureById(id: string): Promise<AxiosResponse<FeatureType>> {
    return apiService.get<AxiosResponse<FeatureType>>(`/features/${id}`)
  }

  static addFeature(data: FeatureType): Promise<AxiosResponse<FeatureType>> {
    return apiService.post<AxiosResponse<FeatureType>>('/features', data)
  }

  static updateFeature(
    id: string,
    data: FeaturePayload,
  ): Promise<AxiosResponse<FeatureType>> {
    return apiService.put<AxiosResponse<FeatureType>>(
      `features/${id}/update`,
      data,
    )
  }

  static createFeature(
    data: FeaturePayload,
  ): Promise<AxiosResponse<FeatureType>> {
    return apiService.post<AxiosResponse<FeatureType>>('/features', data)
  }
}
